document.addEventListener("DOMContentLoaded", newsletterConfirm);

const generalPopup = document.querySelector(".Popup");

function newsletterConfirm(e) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  if (urlParams.get("customer_posted")) {
    const status = urlParams.get("customer_posted") == "true";

    console.log(status);

    setTimeout(() => {
      popup(
        status
          ? `You have successfully subscribed to the newsletter`
          : `There was an issue with your newsletter subscription, please try again later`
      );
    }, 1000);
  }
}

function popup(string) {
  generalPopup.querySelector("span").textContent = string;
  generalPopup.classList.add("Active");

  setTimeout(() => {
    generalPopup.classList.remove("Active");
  }, 5000);
}

subscribe(PUB_SUB_EVENTS.cartError, function (data) {
  popup(data.message);
});
